import {SET_ENV_VARIABLE} from './types'

const initialState = {
    env: ''
}

export const envReducer = (state=initialState,action:any) =>{
    switch(action.type){
        case SET_ENV_VARIABLE: {
            return {
                ...state,
                env: action.env
            }
        }
        default:
            return state
    }
}